/* ============================================================
   WELCOME10 popup — behavior only
   This is a NEW file. Create it as:
     Edit code -> Assets -> Add a new asset -> "Create a blank file"
     -> name it exactly:  welcome10-popup.js
   Paste this entire file's contents into it, then Save.
   ============================================================ */
(function () {
  "use strict";

  // ---- Configurable settings -------------------------------------------
  var DISCOUNT_CODE = "WELCOME10";
  var SHOW_DELAY_MS = 4000;     // how long to wait before showing the popup
  var DISMISS_DAYS = 14;        // how many days to hide it after a visitor closes it
  var STORAGE_KEY = "a4h_welcome10_dismissed_until";
  var SESSION_KEY = "a4h_welcome10_shown_this_session";
  // ------------------------------------------------------------------------

  function nowMs() {
    return new Date().getTime();
  }

  function isDismissed() {
    try {
      var until = window.localStorage.getItem(STORAGE_KEY);
      return !!until && nowMs() < parseInt(until, 10);
    } catch (e) {
      return false; // if storage is unavailable, fail open (show the popup)
    }
  }

  function shownThisSession() {
    try {
      return window.sessionStorage.getItem(SESSION_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markShownThisSession() {
    try {
      window.sessionStorage.setItem(SESSION_KEY, "1");
    } catch (e) {}
  }

  function dismissForDays(days) {
    try {
      var until = nowMs() + days * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {}
  }

  // Don't run at all on cart/checkout pages
  var path = window.location.pathname || "";
  if (path.indexOf("/checkout") === 0 || path.indexOf("/cart") === 0) {
    return;
  }

  if (isDismissed() || shownThisSession()) {
    return;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var overlay = document.getElementById("a4h-welcome10-overlay");
    var dialog = document.getElementById("a4h-welcome10-dialog");
    var closeBtn = document.getElementById("a4h-welcome10-close");
    var dismissBtn = document.getElementById("a4h-welcome10-dismiss");
    var copyBtn = document.getElementById("a4h-welcome10-copy");
    var codeEl = document.getElementById("a4h-welcome10-code");
    var lastFocused = null;

    if (!overlay || !dialog) return;

    function openPopup() {
      lastFocused = document.activeElement;
      overlay.classList.add("a4h-visible");
      overlay.setAttribute("aria-hidden", "false");
      markShownThisSession();
      closeBtn.focus();
      document.addEventListener("keydown", onKeydown, true);
    }

    function closePopup(dismissDurably) {
      overlay.classList.remove("a4h-visible");
      overlay.setAttribute("aria-hidden", "true");
      document.removeEventListener("keydown", onKeydown, true);
      if (dismissDurably) {
        dismissForDays(DISMISS_DAYS);
      }
      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === "Escape") {
        closePopup(true);
        return;
      }
      // simple focus trap
      if (e.key === "Tab") {
        var focusable = dialog.querySelectorAll(
          "button, a[href]"
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    closeBtn.addEventListener("click", function () {
      closePopup(true);
    });

    dismissBtn.addEventListener("click", function () {
      closePopup(true);
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        closePopup(true);
      }
    });

    copyBtn.addEventListener("click", function () {
      var text = codeEl.textContent || DISCOUNT_CODE;
      var done = function () {
        var original = "Copy code";
        copyBtn.textContent = "Copied!";
        copyBtn.classList.add("a4h-copied");
        window.setTimeout(function () {
          copyBtn.textContent = original;
          copyBtn.classList.remove("a4h-copied");
        }, 1800);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, done);
      } else {
        // Fallback for older browsers
        var temp = document.createElement("textarea");
        temp.value = text;
        temp.style.position = "fixed";
        temp.style.opacity = "0";
        document.body.appendChild(temp);
        temp.select();
        try {
          document.execCommand("copy");
        } catch (e) {}
        document.body.removeChild(temp);
        done();
      }
    });

    // Clicking "Start Shopping" counts as a soft dismissal too,
    // so it doesn't pop up again on the very next page.
    document
      .getElementById("a4h-welcome10-cta")
      .addEventListener("click", function () {
        dismissForDays(DISMISS_DAYS);
      });

    window.setTimeout(openPopup, SHOW_DELAY_MS);
  });
})();